import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
} from 'react-accessible-accordion';
import moment from 'moment';
import { BILLING_PRODUCT } from '../constants';
import 'react-accessible-accordion/dist/fancy-example.css';
import Immutable from 'immutable';

const TransactionsRowMobile = ({ transaction }) => {
  return (
    <Accordion accordion={false} key={transaction.get('id')}>
      <AccordionItem>
        <AccordionItemTitle>
          <div>
            <div className={'accordion-header__title'}>Date</div>
            <div className={'accordion-header__item'}>
              {moment.unix(transaction.get('created')).format('YYYY-MM-DD')}
            </div>
          </div>
          <div>
            <div className={'accordion-header__title'}>Items</div>
            <div className={'accordion-header__item'}>{BILLING_PRODUCT}</div>
          </div>
          <div>
            <div className={'accordion-header__title'}>Charge</div>
            <div className={'accordion-header__item'}>
              {' '}
              {transaction.get('amount_due') / 100}$
            </div>
          </div>
          <div>
            <div className={'accordion-header__title'}>Invoice</div>
            <div className={'accordion-header__item'}>
              <a
                className={'transactions__invoice'}
                href={transaction.get('hosted_invoice_url')}
                target={'_blank'}
              >
                {transaction.get('number')}
              </a>
            </div>
          </div>
        </AccordionItemTitle>
      </AccordionItem>
    </Accordion>
  );
};

TransactionsRowMobile.propTypes = {
  transaction: PropTypes.instanceOf(Immutable.Map).isRequired,
};

export default TransactionsRowMobile;



// WEBPACK FOOTER //
// ./app/components/reps/settings/transactions/_TransactionRowMobile.jsx